import { useMemo } from 'react';
import { SEARCH_TYPES, SearchInput } from '@koob/search';
import {
  KoobSegmentedControl,
  KoobSegmentedControlItem,
} from '@koob/ui/src/components/KoobSegmentedControl';
import {
  useSearchHotels,
  useSetSearchHotels,
  useTripFilters,
} from '../../hooks/useTripStoreSelectors';
import { useUpdateTripFilter } from '../../hooks/useUpdateTripFilter';

interface Props {
  t: (key: string) => string;
  countries: unknown[];
  locale: string;
}

// Location search and the experiences / hotels switch.
export default function TripFilterSearch({ t, countries, locale }: Props) {
  const tripFilters = useTripFilters();
  const searchHotels = useSearchHotels();
  const setSearchHotels = useSetSearchHotels();
  const updateFilter = useUpdateTripFilter();

  const searchTypes = useMemo(
    () => [
      SEARCH_TYPES.CITY,
      SEARCH_TYPES.REGION,
      SEARCH_TYPES.COUNTRY,
      searchHotels ? SEARCH_TYPES.HOTEL : SEARCH_TYPES.PROGRAM,
    ],
    [searchHotels],
  );

  return (
    <div className="flex items-center gap-2">
      <div className="min-w-0 max-w-md flex-1">
        <SearchInput
          block
          rounded="full"
          value={tripFilters?.location?.[0]}
          onChange={(value: unknown) =>
            updateFilter('location', value ? [value] : [])
          }
          types={searchTypes}
          fromOrganizationId={tripFilters?.dmcId?.value}
          searchedCountries={countries}
          locale={tripFilters?.locale ?? locale}
        />
      </div>

      <div className="ml-auto shrink-0">
        <KoobSegmentedControl
          value={String(searchHotels)}
          onValueChange={(value: string) => setSearchHotels(value === 'true')}
        >
          <KoobSegmentedControlItem
            value="false"
            aria-label={t('tooltip.experiences')}
          >
            <div className="flex items-center gap-1.5 px-1">
              <i className="fa-light fa-layer-group" />
              <span>{t('tooltip.experiences')}</span>
            </div>
          </KoobSegmentedControlItem>
          <KoobSegmentedControlItem
            value="true"
            aria-label={t('tooltip.hotels')}
          >
            <div className="flex items-center gap-1.5 px-1">
              <i className="fa-light fa-hotel" />
              <span>{t('tooltip.hotels')}</span>
            </div>
          </KoobSegmentedControlItem>
        </KoobSegmentedControl>
      </div>
    </div>
  );
}
